export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '提现管理';
